import "./scripts/image_lazy";

import "./styles/image_lazy.scss";
